const { initNewsletterForm } = require('newsletter/client');
const onScroll = require('./onScroll');
import ScreencastPlayer from './screencastPlayer';

const comments = document.querySelector('.comments');
const commentsContainer = document.querySelector('.screencast-tabmodules__module_description');
const commentsTabletContainer = document.querySelector('.screencast-tabmodules__module_comments');
const playlist = document.querySelector('.playlist');
const playlistModule = document.querySelector('.screencast-tabmodules__module_playlist');
const playlistMainContainer = document.querySelector('.screencast-player__nav-inner');
const main = document.querySelector('.screencast-player__main');

let onScrollBound = false;

function init() {
  initPlayer();
  initNewsletterForm();
}

function initPlayer() {
  new ScreencastPlayer();
}

function addScrollIfTablet() {
  const isTablet = document.documentElement.clientWidth <= 890;
  if (isTablet) {
    main.removeEventListener('scroll', onScroll);
  } else {
    document.documentElement.scrollTop = 0;
    if (!onScrollBound) {
      main.addEventListener('scroll', onScroll);
      onScrollBound = true;
    }
  }
}

// TODO: what if tablet?
window.addEventListener('resize', () => {
  addScrollIfTablet();
});

addScrollIfTablet();

init();

